import { baseApi } from "./baseApi";

export const masterApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmployees: builder.query<
      {
        employee_id: string;
        full_name: string;
        email: string;
      }[],
      void
    >({
      query: () => ({
        url: "/masterlist",
        method: "GET",
      }),
      transformResponse: (response: { success: boolean; data: any[] }) =>
        response.data, // pick only the employee array
    }),
  }),
});

export const { useGetEmployeesQuery } = masterApi;
